/* Staff module */
export const SET_STAFF_STATION = 'setStaffStation';

/* input pad module */
export const ON_INPUT_PAD = 'onInputPad';